<template>
  <div class="renewal">
    <div class="renewal__header">
      <SelectInput
        v-model="searchValue"
        style="margin-right:20px"
        title="全部"
      />
      <span>
      </span>
      <span style="margin-top:20px">
        <el-form
          ref="form"
          :model="form"
          label-width="80px"
        >
          <el-form-item label="激活时间：">
            <el-col :span="10">
              <el-date-picker
                size="small"
                type="datetime"
                placeholder="开始日期"
                v-model="form.beginTime"
                style="width: 200px;"
              ></el-date-picker>
              -
              <el-date-picker
                size="small"
                type="datetime"
                placeholder="结束日期"
                v-model="form.endTime"
                style="width: 200px;"
              ></el-date-picker>
            </el-col>
          </el-form-item>
        </el-form>
      </span>
      <span>
        设备状态:
        <el-select
          v-model="carState"
          placeholder="车辆状态"
          size="small"
          style="width: 100px;margin-right:20px"
        >
          <el-option
            v-for="item in carOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </span>
      <span>
        状态:
        <el-select
          v-model="state"
          placeholder="状态"
          size="small"
          style="width: 100px;margin-right:20px"
        >
          <el-option
            v-for="item in stateOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </span>
      <span class="btnOptions">
        <el-button
          v-for="(item, index) in btns"
          :key="index"
          size="small"
          :type="item.type"
          @click="open(item.value,index)"
        >{{item.title}}</el-button>
      </span>

      <span style="margin-left: auto">
        <el-button
          style="margin-left: 32px"
          size="small"
          type="primary"
          @click="getRenewalReport()"
        >查询</el-button>

        <!-- <el-button size="small">导出</el-button> -->
      </span>
      <div class="otherBtns">
        <el-button
          v-for="(item, index) in otherBtns"
          :key="index"
          size="small"
          type="primary"
          @click="myFn(item.value)"
        >{{item.title}}</el-button>
      </div>

    </div>
    <div class="renewal__content">
      <el-table
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 1)"
        :data="tableData"
        border
        stripe
        row-key="vehicleId"
        height="100%"
        max-height="100%"
        style="min-width: 100%"
        size="mini"
        ref="table"
        @selection-change="val => multipleSelection = val"
      >
        <el-table-column
          type="selection"
          width="40"
        >
        </el-table-column>
        <el-table-column
          v-for="(item, index) in columns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.width"
          align="center"
          :fixed="item.fixed"
        >
          <template slot-scope="scope">{{item.type === 1?scope.row["state"] === 0?"正常":scope.row["state"] ===1 ?"过期":"未激活":scope.row[item.prop]||"--"}}</template>
        </el-table-column>

        <el-table-column
          fixed="right"
          label="操作"
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="renewalOne(scope.row)"
            >续费</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 表格结束 -->

      <!-- 分页开始 -->
      <el-pagination
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :page-sizes="[20, 50, 100]"
        @size-change="getRenewalReport"
        @current-change="getRenewalReport"
        layout="total,sizes, prev, pager, next, jumper"
        :total="total"
      />
      <!-- 分页结束 -->
    </div>
    <LazyRender slot="plugins">
      <autoDialog
        :visible.sync="autoDialogShow"
        @autoClick="autoClick"
      />
      <autoRecord
        :visible.sync="autoRecordShow"
        :title.sync="autoRecodeTitle"
        @autoRecordClick="autoRecordClick"
      />
      <renewalDialog
        :visible.sync="renewalDialogShow"
        :data.sync="renewalData"
        :auto.sync="auto"
        @updateok="updateok"
      />
    </LazyRender>
  </div>
</template>
<script>
import day from "dayjs";
import SelectInput from "@/components/SelectInput/index.vue";
import autoDialog from "./autoDialog.vue";
import LazyRender from "@/components/LazyRender/index.vue";
import autoRecord from "./autoRecord.vue";
import renewalDialog from "@/components/Renewal/index.vue";

export default {
  components: {
    SelectInput,
    autoDialog,
    LazyRender,
    autoRecord,
    renewalDialog
  },
  props: {
    activeName: {
      type: String
    }
  },
  data() {
    return {
      loading: false,
      renewalData: [],
      multipleSelection: [],
      renewalDialogShow: false,
      currentPage: 1,
      pageSize: 100,
      total: 0,
      auto: false,
      searchValue: null,
      renewalState: 0,
      carState: null,
      state: null,
      autoDialogShow: false,
      autoRecordShow: false,
      autoRecodeTitle: "",
      expireTime: 3 * 24 * 3600,
      form: {
        beginTime: null,
        endTime: null
      },
      stateOptions: [
        {
          value: null,
          label: "全部"
        },
        {
          value: 0,
          label: "正常"
        },
        {
          value: 1,
          label: "过期"
        },
        {
          value: 2,
          label: "未激活"
        }
      ],
      carOptions: [
        {
          value: null,
          label: "全部"
        },
        {
          value: "离线",
          label: "离线"
        },
        {
          value: "在线",
          label: "在线"
        },
        {
          value: "从未上线",
          label: "从未上线"
        }
        // {
        //   value: "异常登出",
        //   label: "异常登出"
        // },
        // {
        //   value: "休眠",
        //   label: "休眠"
        // }
      ],
      columns: [
        { prop: "index", label: "序号", width: 50, type: 0, fixed: true },
        {
          prop: "organizationName",
          label: "所属组织",
          width: 80,
          type: 0,
          fixed: false
        },
        // { prop: "plate", label: "设备名", width: 80, type: 0, fixed: false },
        {
          prop: "terminalNo",
          label: "设备号",
          width: 180,
          type: 0,
          fixed: false
        },
        {
          prop: "activeTime",
          label: "激活时间",
          width: 150,
          type: 0,
          fixed: false
        },
        {
          prop: "expireDate",
          label: "过期时间",
          width: 150,
          type: 0,
          fixed: false
        },
        { prop: "state", label: "状态", width: 80, type: 1, fixed: false },
        {
          prop: "vehState",
          label: "设备状态",
          width: 200,
          type: 0,
          fixed: false
        },
        // { prop: "vin", label: "VIN号", width: 150, type: 0, fixed: false }
      ],
      otherBtns: [
        { title: "批量续费", value: 0 },
        { title: "自定义续费", value: 1 }
      ],
      btns: [
        { title: "3天", type: "success", value: 3 },
        { title: "7天", type: "primary", value: 7 },
        { title: "自定义", type: "primary", value: 0 }
      ],
      tableData: []
    };
  },
  mounted() {
    this.getRenewalReport();
    const that = this;
    window.onresize = () => {
      return (() => {
        // console.log("onresize")
        that.$refs.table.doLayout();
        // window.screenWidth = document.body.clientWidth;
        // that.screenWidth = window.screenWidth;
      })();
    };
  },

  computed: {},
  watch: {
    activeName: {
      handler() {
        this.$nextTick(() => {
          this.$refs.table.doLayout();
        });
      },
      deep: true
    },
    form: {
      handler(val) {
        console.log(val, "00000");
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    open(val, index) {
      this.btns.map(item => {
        item.type = "primary";
      });
      this.btns[index].type = "success";
      if (val == 0) {
        this.autoDialogShow = true;
      } else {
        this.expireTime = val * 24 * 3600;
        this.getRenewalReport();
      }
    },
    //单个设备续费
    renewalOne(val) {
      this.renewalData = val;
      this.auto = false;
      this.renewalDialogShow = true;
    },
    //续费报表查询
    async getRenewalReport() {
      this.loading = true;
      this.multipleSelection = [];
      let params = {
        activationTmeEnd:
          (this.form.endTime &&
            day(this.form.endTime).format("YYYY-MM-DD HH:mm:ss")) ||
          "",
        activationTmeStart:
          (this.form.beginTime &&
            day(this.form.beginTime).format("YYYY-MM-DD HH:mm:ss")) ||
          "",
        expireTime: this.expireTime,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        vehicleState: this.carState,
        isState: this.state
      };
      if (
        this.searchValue != null &&
        this.searchValue.hasOwnProperty("vehicleId") &&
        this.searchValue.hasOwnProperty("groupId")
      ) {
        params.vehicleId = this.searchValue.vehicleId;
        params.organizationId = this.searchValue.groupId;
      }
      if (
        this.searchValue != null &&
        !this.searchValue.hasOwnProperty("vehicleId") &&
        this.searchValue.hasOwnProperty("organizationId")
      ) {
        params.organizationId = this.searchValue.organizationId;
      }
      try {
        const { data, total } = await this.$API.queryVehicleExpire(params);
        this.tableData = data.map((item, index) => ({
          ...item,
          index: (this.currentPage - 1) * this.pageSize + index + 1
        }));
        this.total = total;
        this.loading = false;
        if (total === 0) {
          this.$msg({
            showClose: true,
            message: "暂无数据",
            type: "success"
          });
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
        this.$msg({
          showClose: true,
          message: error.msg,
          type: "error"
        });
      }
    },

    myFn(val) {
      this.renewalData = [];
      if (val === 0) {
        if (this.multipleSelection.length === 0) {
          this.$msg({
            showClose: true,
            message: "请选择设备！",
            type: "error"
          });
          return;
        } else {
          this.renewalData = this.multipleSelection;
          this.auto = false;
          this.renewalDialogShow = true;
        }
      } else if (val === 1) {
        this.autoRecodeTitle =
          "请输入需要续费的设备号，并用英文逗号或者换行隔开！";
        this.autoRecordShow = true;
      }
    },
    //自定义天数查询
    autoClick(val) {
      this.autoDialogShow = false;
      this.expireTime = val * 24 * 3600;
      this.getRenewalReport();
    },
    //自定义续费
    autoRecordClick(val) {
      if (val === null || val === "") {
        this.$msg({
          showClose: true,
          message: "请输入设备号！",
          type: "error"
        });
        return;
      }
      let count = 0;
      var arr = [];
      //处理自定义续费输入内容
      for (let i of val.split("\n")) {
        if (i != "") {
          i.replace(/\s/g, "")
            .split(",")
            .map(item => {
              item != "" && count++;
              item != "" && arr.push(item);
            });
        }
      }
      // console.log(count);
      // console.log(arr.join(","));
      this.renewalData = [{ count: count, data: arr }];
      this.auto = true;
      this.renewalDialogShow = true;
      this.autoRecordShow = false;
    },
    updateok() {
      this.$emit('update');
      this.getRenewalReport();
    },
  }
};
</script>
<style lang="scss" scoped>
.renewal {
  overflow: hidden;
  height: calc(100vh - 200px);
  display: flex;
  position: relative;
  &__header {
    position: absolute;
    top: 0;
    display: flex;
    height: 40px;
    align-items: center;
    width: 100%;
    & > span {
      white-space: nowrap;
      padding: 0 5px;
    }
    .btnOptions {
      // .el-button + .el-button {
      //   margin-left: 1px;
      // }
      // .el-button:nth-child(1) {
      //   border-top-left-radius: 4px;
      //   border-bottom-left-radius: 4px;
      // }

      // .el-button:nth-child(3) {
      //   border-top-right-radius: 4px;
      //   border-bottom-right-radius: 4px;
      // }
    }
    .otherBtns {
      position: absolute;
      top: 50px;
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      // .el-button + .el-button {
      //   margin-left: 1px;
      // }
      // .el-button:nth-child(1) {
      //   border-top-left-radius: 4px;
      //   border-bottom-left-radius: 4px;
      // }

      // .el-button:nth-child(2) {
      //   border-top-right-radius: 4px;
      //   border-bottom-right-radius: 4px;
      // }
    }
  }

  &__content {
    width: 100%;
    position: absolute;
    top: 108px;
    height: calc(100vh - 358px);
    transition: all 0.2s;
  }
}
</style>